document.addEventListener('DOMContentLoaded', () => {
  console.log('modal');
  const triggers = document.querySelectorAll('[data-modal-trigger]');

  triggers.forEach(trigger => {
    const modalId = trigger.getAttribute('data-modal-trigger');
    const modal = document.getElementById(modalId);
    if (!modal || typeof modal.showModal !== 'function') return;

    setupModal(trigger, modal);
  });

});

/**
 * モーダルをセットアップ
 * @param {HTMLElement} trigger - モーダルを開くボタン
 * @param {HTMLElement} modal - モーダル要素
 */
function setupModal(trigger, modal) {
  let lastFocusedElement;

  const closeModal = () => {
    modal.close();
    modal.classList.remove('is-active');
    document.body.classList.remove('modal-open');
    lastFocusedElement?.focus();
  };

  const trapFocus = (e) => {
    const focusable = modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    const focusables = [...focusable];
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
    }
  };

  modal.addEventListener('keydown', trapFocus); // ← ここに移動

  const openModal = () => {
    lastFocusedElement = document.activeElement;
    modal.showModal();
    modal.classList.add('is-active');
    document.body.classList.add('modal-open');

    const firstFocusable = modal.querySelector(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    firstFocusable?.focus();
  };

  trigger.addEventListener('click', openModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  const closeBtn = modal.querySelector('.modal__close');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
}
